

























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { AvailableItem } from './index.vue'

@Component
export default class ConfirmPurchaseModal extends Vue {
	@Prop({ type: Boolean, default: false }) readonly visible!: boolean
	@Prop({ type: Object, default: null }) readonly item!: AvailableItem | null
	@Prop({ type: Boolean, default: false }) readonly loading!: boolean
}
